import { useLocalReactionStore } from "designSystem/hooks";
import { useLocale } from "designSystem/locale";
import React, { FunctionComponent } from "react";
import { createRecipeLabelStore } from "../RecipeLabelUpdateService";
import { RecipeLabelStoreContext } from "./RecipeLabelStore";
import RecipeOperationDialog, { RecipeOperationDialogProps } from "./RecipeOperationDialog";

const UpdateRecipeLabelOperation: FunctionComponent<RecipeOperationDialogProps> = (props) => {
	const loc = useLocale();
	const store = useLocalReactionStore(() => {
		const actionController = props.actionController;
		const doc = actionController.getNode();
		
		return createRecipeLabelStore(doc, loc, actionController, "RecipeUpdateFoodLabelDataSheet");
	});
	return (
		<RecipeLabelStoreContext.Provider value={store}>
			{store &&
				<RecipeOperationDialog {...props} />
			}
		</RecipeLabelStoreContext.Provider>
	);
};

export default UpdateRecipeLabelOperation;